module.exports = __webpack_public_path__ + "img/8.b38ce0c4.svg";